import React from 'react'
import { Alert } from 'antd'
import { useAccountContext } from '../../../context/account'

const SwitchAccountNotice = () => {
	const { account } = useAccountContext()
	return (
		<>
			{account.user && (
				<Alert
					type="warning"
					showIcon
					message={`You are managing ${account.user.first_name} ${account.user.last_name} profile.`}
					style={{ marginBottom: 10 }}
				></Alert>
			)}
		</>
	)
}

export default SwitchAccountNotice
